'use client';

import { c as _c } from "react/compiler-runtime";
import { useCommonData } from '@udemy-v2/common-data';
import { publishEvent } from '@udemy-v2/event-tracking';
import { useClpPurchaseContext } from '@/features/course-landing-page/context/clp-purchase-context.react-component';
import { useClpNoticeContext } from '@/features/course-landing-page/context/clp-notice-context-provider.react-component';
import { PlanPeriodStyle, SubscribeFromPageCookie, SubscriptionCTA, SubscriptionCTAClickEvent, SubscriptionOfferPresented } from '@udemy-v2/react-subscription-browse';
import { useClpCourse } from '@/features/course-landing-page/context/clp-course-provider.react-component';
import { useFeatures } from '@udemy-v2/react-experimentation';
import styles from './subscription-sticky-footer-cta.module.scss';
import { useI18n } from '@udemy-v2/i18n';
const UI_REGION = 'subscription_sticky_footer';
export const SubscriptionStickyFooterCta = () => {
  const $ = _c(65);
  const {
    unwrappedConsumerSubscriptionPlan,
    subscriptionCTAConfiguration,
    subscriptionTiersEnabled
  } = useClpPurchaseContext();
  const clpNoticeContext = useClpNoticeContext();
  const course = useClpCourse();
  const commonData = useCommonData();
  const subscriptionPriceBoxNotice = clpNoticeContext?.subscriptionPriceBoxNoticeData;
  const {
    gettext
  } = useI18n();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["change_cta_language_for_pp"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    featureVariantAssignments
  } = useFeatures(t0);
  let T0;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[1] !== commonData?.user?.country || $[2] !== course.frontendTrackingId || $[3] !== course.id || $[4] !== featureVariantAssignments || $[5] !== gettext || $[6] !== subscriptionCTAConfiguration || $[7] !== subscriptionPriceBoxNotice || $[8] !== subscriptionTiersEnabled || $[9] !== unwrappedConsumerSubscriptionPlan) {
    t18 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const changeCtaLangFeatureAssignment = featureVariantAssignments.get("change_cta_language_for_pp")?.configuration as {
        getStarted: boolean;
        getPersonalPlan: boolean;
      } | undefined;
      let t19;
      if ($[29] !== course.id || $[30] !== subscriptionTiersEnabled || $[31] !== unwrappedConsumerSubscriptionPlan) {
        t19 = () => {
          SubscribeFromPageCookie.set("course_landing_page", parseInt(course.id, 10));
          if (subscriptionTiersEnabled && unwrappedConsumerSubscriptionPlan) {
            publishEvent(new SubscriptionCTAClickEvent({
              planId: unwrappedConsumerSubscriptionPlan.id,
              planType: unwrappedConsumerSubscriptionPlan.productType,
              ctaType: unwrappedConsumerSubscriptionPlan.trialPeriodDays ? "trial" : "paid",
              uiRegion: UI_REGION,
              courseId: parseInt(course.id, 10),
              planPriceIds: unwrappedConsumerSubscriptionPlan.planPriceOptionIds
            }));
          }
        };
        $[29] = course.id;
        $[30] = subscriptionTiersEnabled;
        $[31] = unwrappedConsumerSubscriptionPlan;
        $[32] = t19;
      } else {
        t19 = $[32];
      }
      const handleCtaClick = t19;
      let t20;
      if ($[33] !== commonData?.user?.country || $[34] !== course.frontendTrackingId || $[35] !== course.id || $[36] !== subscriptionTiersEnabled || $[37] !== unwrappedConsumerSubscriptionPlan) {
        t20 = subscriptionTiersEnabled && unwrappedConsumerSubscriptionPlan ? () => {
          publishEvent(new SubscriptionOfferPresented({
            subscriptionPlan: unwrappedConsumerSubscriptionPlan,
            productType: unwrappedConsumerSubscriptionPlan.productType,
            countryCode: commonData?.user?.country ?? "",
            courseId: parseInt(course.id, 10),
            courseTrackingId: course.frontendTrackingId ?? null,
            uiRegion: UI_REGION
          }));
        } : undefined;
        $[33] = commonData?.user?.country;
        $[34] = course.frontendTrackingId;
        $[35] = course.id;
        $[36] = subscriptionTiersEnabled;
        $[37] = unwrappedConsumerSubscriptionPlan;
        $[38] = t20;
      } else {
        t20 = $[38];
      }
      const handleOfferImpression = t20;
      if (!unwrappedConsumerSubscriptionPlan) {
        t18 = null;
        break bb0;
      }
      let t21;
      if ($[39] !== gettext) {
        t21 = config => {
          if (!config) {
            return gettext("Start subscription");
          }
          if (config.getStarted && !config.getPersonalPlan) {
            return gettext("Get started");
          }
          if (!config.getStarted && config.getPersonalPlan) {
            return gettext("Get Personal Plan");
          }
          return gettext("Start subscription");
        };
        $[39] = gettext;
        $[40] = t21;
      } else {
        t21 = $[40];
      }
      const ctaText = t21;
      t16 = "subscription-sticky-footer";
      t17 = "subscription-sticky-footer";
      T0 = SubscriptionCTA;
      t1 = styles["subscription-cta"];
      t2 = UI_REGION;
      t3 = styles["cta-subtitle"];
      t4 = "subscription-sticky-footer-button";
      t5 = "primary";
      t6 = handleCtaClick;
      t7 = handleOfferImpression;
      t8 = parseInt(course.id, 10);
      t9 = false;
      t10 = unwrappedConsumerSubscriptionPlan;
      if ($[41] !== subscriptionCTAConfiguration || $[42] !== subscriptionPriceBoxNotice) {
        t11 = subscriptionCTAConfiguration?.upgradeUrl ? {
          ...subscriptionPriceBoxNotice,
          cta_1_url: subscriptionCTAConfiguration.upgradeUrl
        } : subscriptionPriceBoxNotice;
        $[41] = subscriptionCTAConfiguration;
        $[42] = subscriptionPriceBoxNotice;
        $[43] = t11;
      } else {
        t11 = $[43];
      }
      t12 = PlanPeriodStyle.SINGLE;
      t13 = subscriptionCTAConfiguration?.directCheckout;
      t14 = subscriptionCTAConfiguration?.selectPlanText;
      t15 = subscriptionCTAConfiguration?.purchaseCtaText || ctaText(changeCtaLangFeatureAssignment);
    }
    $[1] = commonData?.user?.country;
    $[2] = course.frontendTrackingId;
    $[3] = course.id;
    $[4] = featureVariantAssignments;
    $[5] = gettext;
    $[6] = subscriptionCTAConfiguration;
    $[7] = subscriptionPriceBoxNotice;
    $[8] = subscriptionTiersEnabled;
    $[9] = unwrappedConsumerSubscriptionPlan;
    $[10] = T0;
    $[11] = t1;
    $[12] = t10;
    $[13] = t11;
    $[14] = t12;
    $[15] = t13;
    $[16] = t14;
    $[17] = t15;
    $[18] = t16;
    $[19] = t17;
    $[20] = t18;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    T0 = $[10];
    t1 = $[11];
    t10 = $[12];
    t11 = $[13];
    t12 = $[14];
    t13 = $[15];
    t14 = $[16];
    t15 = $[17];
    t16 = $[18];
    t17 = $[19];
    t18 = $[20];
    t2 = $[21];
    t3 = $[22];
    t4 = $[23];
    t5 = $[24];
    t6 = $[25];
    t7 = $[26];
    t8 = $[27];
    t9 = $[28];
  }
  if (t18 !== Symbol.for("react.early_return_sentinel")) {
    return t18;
  }
  let t19;
  if ($[44] !== T0 || $[45] !== t1 || $[46] !== t10 || $[47] !== t11 || $[48] !== t12 || $[49] !== t13 || $[50] !== t14 || $[51] !== t15 || $[52] !== t2 || $[53] !== t3 || $[54] !== t4 || $[55] !== t5 || $[56] !== t6 || $[57] !== t7 || $[58] !== t8 || $[59] !== t9) {
    t19 = <T0 className={t1} uiRegion={t2} subtitleClassName={t3} data-purpose={t4} offerCtaStyle={t5} onCTAClick={t6} trackImpression={t7} courseId={t8} includeTrialDaysOnCta={t9} plan={t10} noticeData={t11} planPeriodStyle={t12} directCheckout={t13} selectPlanText={t14} purchaseCtaText={t15} />;
    $[44] = T0;
    $[45] = t1;
    $[46] = t10;
    $[47] = t11;
    $[48] = t12;
    $[49] = t13;
    $[50] = t14;
    $[51] = t15;
    $[52] = t2;
    $[53] = t3;
    $[54] = t4;
    $[55] = t5;
    $[56] = t6;
    $[57] = t7;
    $[58] = t8;
    $[59] = t9;
    $[60] = t19;
  } else {
    t19 = $[60];
  }
  let t20;
  if ($[61] !== t16 || $[62] !== t17 || $[63] !== t19) {
    t20 = <div data-testid={t16} data-purpose={t17}>{t19}</div>;
    $[61] = t16;
    $[62] = t17;
    $[63] = t19;
    $[64] = t20;
  } else {
    t20 = $[64];
  }
  return t20;
};